import { render, staticRenderFns } from "./Ckeditor.vue?vue&type=template&id=82c0d9f0&scoped=true&"
import script from "./Ckeditor.vue?vue&type=script&lang=js&"
export * from "./Ckeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c0d9f0",
  null
  
)

export default component.exports